import React, { useEffect, useRef, useState } from "react";
import Button from "../../../components/elements/button";
import { Link, useLocation, useParams } from "react-router-dom";
import SidebarWOdetails from "./sidebarWOdetails";
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!
import interactionPlugin from '@fullcalendar/interaction';
import Select from 'react-select'
import Icon from "../../../components/icons";
import moment from 'moment';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/scale.css';
import 'tippy.js/themes/material.css';
import Tippy from '@tippyjs/react';
import SelectBox from "../../../components/elements/form/selectBox";
import { Controller, useForm } from "react-hook-form";
import { useWorkOrderApi } from "../../../store/api/hooks/workOrderApiHook";
import toast from "react-hot-toast";
import { URLS } from "../../../_config";
import AssignToModal from "./assignTo.modal";
import Filters from '../../../components/filters';
import { filterConfigType } from '../../../_config/types';
import { useFacilityManagersSelector } from '../../../store/selectors/masterSelector';
import { useCommonApi } from '../../../store/api/hooks/commonApiHook';
import { useFacilitiesApi } from '../../../store/api/hooks/facilitiesApiHook';
import { useWorkRequestApi } from "../../../store/api/hooks/workRequestApiHook";
import ScheduleModalWorkOrder from "./schedulepopupWorkOrder";
import Drawer from '../../../components/Drawer';
import { useUserSelector } from "../../../store/selectors/userSelector";
import { getPermissionInfo } from "../../../_common/functions";


interface Props {
    createWorkOrderOn: (date: any) => void;
    createScheduleOn: (date: any) => void;
    canEdit?: boolean;
}

const CalendarWO: React.FC<Props> = ({ createWorkOrderOn, createScheduleOn, canEdit = true }) => {
    const { control, handleSubmit, setValue, reset, formState: { errors }, watch, getValues } = useForm<any>({
        defaultValues: {
            //assignmentType: 1,
            assignmentType: { label: "All", value: 0 },
        },
    });
    const loggedinuser: any = useUserSelector();
    const location = useLocation();
    const calendarRef = useRef<any>(null);
    const workOrderAPI: any = useWorkOrderApi();
    const workRequestAPI: any = useWorkRequestApi();
    const facilityApi: any = useFacilitiesApi();
    const commonApi: any = useCommonApi();
    const filtersRef = useRef<any>();

    const [calendarView, setCalendarView] = useState<string>(`dayGridMonth`);
    const [isToday, setIsToday] = useState<boolean>(false);
    const [headerDatetext, setHeaderDateText] = useState<string>(``);
    const [assignmentTypelist, setAssignmentTypelist] = useState<any[] | null>(null);
    const [eventsData, setEventsData] = useState<any[]>([]);
    const [selectedDateEvent, setSelectedDateEvent] = useState<any>(null);
    // const [selectedEvent, setSelectedEvent] = useState<any>(null); // Commented - no longer using modal
    const [calendarHeight, setCalendarHeight] = useState<string | number>("auto");

    // Filter related states
    const [facilityoption, setFacilityoption] = useState<any>([]);
    const [priorityoption, setPriorityoption] = useState<any>([]);
    const [filters, setFilters] = useState<any>({});
    const [filtersApplied, setFiltersApplied] = useState<any>({ generalFilter: false });
    const [filtersInitialized, setFiltersInitialized] = useState<boolean>(false);

    const blankDateOption: any = useRef();
    // const eventOption: any = useRef(); // Commented - no longer using modal
    const assignToModal: any = useRef();
    const schedulerDrawerRef: any = useRef();
    const schedulerModalRef: any = useRef();

    const selectedAssignType = watch(`assignmentType`);
    const users = useFacilityManagersSelector();

    // State for the scheduler popup
    const [schedulerEditData, setSchedulerEditData] = useState<any>(null);
    const [schedulerDropInfo, setSchedulerDropInfo] = useState<any>(null);

    const getCalenderEvents = async () => {
        const events: any[] = await new Promise((resolve, reject) => {
            const startDate = moment.utc(calendarRef.current.getApi().getCurrentData().dateProfile.activeRange.start).local().format(`YYYY-MM-DD`);
            const endDate = moment.utc(calendarRef.current.getApi().getCurrentData().dateProfile.activeRange.end).subtract(1, `seconds`).local().format(`YYYY-MM-DD`);
            const data: any = getValues();
            data.assignmentType = data.assignmentType ? data.assignmentType.value : null;

            const payload: any = {
                startDate: startDate,
                endDate: endDate,
                woAssignmentTypeIDs: data.assignmentType != 0 ? data.assignmentType : '',
                //schedulerID: 0
            };

            // Add filters to API payload
            if (filters) {
                Object.keys(filters).map((key: any) => {
                    if (filters[key]) {
                        if (key === `startDate` || key === `endDate`) {
                            // Don't override the calendar range dates, use different key names for filter dates
                            if (key === `startDate`) {
                                payload[`plannedStartDate`] = moment(filters[key]).format(`YYYY-MM-DD`);
                            } else if (key === `endDate`) {
                                payload[`plannedEndDate`] = moment(filters[key]).format(`YYYY-MM-DD`);
                            }
                        } else {
                            payload[key] = filters[key];
                        }
                    }
                });
            }

            if (loggedinuser && getPermissionInfo(location.pathname, "Can Access Only Own Task", loggedinuser)) {
                payload.canAccessOwnWOOnly = true;
            }
            if (loggedinuser && getPermissionInfo(location.pathname, "Can Access Tasks where the related Request is owned by self", loggedinuser)) {
                payload.canAccessOwnWOOnly = true;
                payload.canAccessWOByOwnRequest = true;
            }

            workOrderAPI.GetWorkOrderList(payload, (resp: any) => {
                if (resp.workOrderList == null || resp.workOrderList.length == 0) {
                    resolve([]);
                } else {
                    let eventsList = resp.workOrderList.map((event: any) => {
                        console.log("event =>", event);
                        const eventobj: any = {
                            //title: 'RRRR'+event.workOrderCode + ' ' + event.description,
                            title: event.woUserMappings + ' - ' + event.description,
                            description: event.description,
                            //date: moment.utc(event.startDate).local().format(`YYYY-MM-DD`),
                            //start: moment.utc(event.startDate).local().format(`YYYY-MM-DD HH:mm:ss`),
                            //end: moment.utc(event.endDate).local().format(`YYYY-MM-DD HH:mm:ss`),
                            backgroundColor: event.woStatusHexCode || `#3D7541`,
                            textColor: event.woEventTextColor || `#ffffff`,
                            borderColor: event.woStatusHexCode || `#3D7541`,
                            wo: event
                        };
                        //console.log(moment.utc(event.startDate).local().format(`YYYY-MM-DD`) +  `===` + moment.utc(event.endDate).local().format(`YYYY-MM-DD`));
                        if (moment.utc(event.startDate).local().format(`YYYY-MM-DD`) === moment.utc(event.endDate).local().format(`YYYY-MM-DD`)) {
                            eventobj[`date`] = moment.utc(event.startDate).local().format(`YYYY-MM-DD`);
                        } else {
                            eventobj[`start`] = moment.utc(event.startDate).local().format(`YYYY-MM-DD HH:mm:ss`);
                            eventobj[`end`] = moment.utc(event.endDate).local().format(`YYYY-MM-DD HH:mm:ss`);
                        }
                        return eventobj;
                    }) || [];
                    console.log("eventsList", eventsList)
                    resolve(eventsList);
                }

            }, (error: any) => {
                console.log("error =>", error);
                toast.error(error);
                reject([]);
            });
        });
        setEventsData(events);
    }

    const changeCalendarView = (view: string) => {
        if (calendarRef.current) {
            calendarRef.current.getApi().changeView(view);
            setCalendarView(view);
        }
    }

    const navigateCalendar = (type: string) => {
        if (calendarRef.current) {
            const calendarApi = calendarRef.current.getApi();
            if (calendarApi) {
                switch (type) {
                    case `prev`: {
                        calendarApi.prev();
                        break;
                    }
                    case `next`: {
                        calendarApi.next();
                        break;
                    }
                    case `today`: {
                        calendarApi.today();
                        break;
                    }
                }
                getCalenderEvents();
            }
        }
    }

    const init_page_date = async () => {
        const assignmenttyperesp: any[] = await new Promise((resolve, reject) => {
            workOrderAPI.GetWOAssignmentTypeList({}, (resp: any) => {
                let deptlist = resp.workOrderAssignmentTypeList.map((assignmentType: any) => {
                    return {
                        label: assignmentType.woAssignmentTypeName,
                        value: assignmentType.woAssignmentTypeID,
                    };
                }) || [];
                //resolve(deptlist);
                resolve([{ label: "All", value: 0 }, ...deptlist]);
            }, (error: any) => {
                console.log("error =>", error);
                toast.error(error);
                reject([]);
            });
        });
        setAssignmentTypelist(assignmenttyperesp);
        setValue(`assignmentType`, assignmenttyperesp[0] || null);
        setHeaderDateText(moment().format(`MMMM DD, YYYY`));
        moment().isSame(moment(), `day`) ? setIsToday(true) : setIsToday(false);
        if (filtersInitialized) {
            getCalenderEvents();
        }
    }

    const init_master_data = async () => {
        // Fetch facility list
        const facilityapiresp = await new Promise((resolve, reject) => {
            facilityApi.getFacilityList({}, (resp: any) => {
                let facilitylist: any = [];
                resp.facilityList.map((facilist: any) => {
                    facilitylist.push({
                        label: facilist.facilityName,
                        value: facilist.facilityID,
                        data: facilist
                    });
                });
                resolve(facilitylist);
            }, (error: any) => {
                console.log("error =>", error);
                toast.error(error);
                reject(error);
            });
        }).catch((error: any) => []);
        setFacilityoption(facilityapiresp);

        // Fetch priority list
        const priorityapiresp = await new Promise((resolve, reject) => {
            workRequestAPI.GetPriorityList({}, (resp: any) => {
                let prioritylist: any = [];
                resp.workRequestPriorityList.map((facilist: any) => {
                    prioritylist.push({
                        label: facilist.workRequestPriorityName,
                        value: facilist.workRequestPriorityID,
                        data: facilist,
                    });
                });
                resolve(prioritylist);
            }, (error: any) => {
                console.log("error =>", error);
                toast.error(error);
                reject(error);
            });
        }).catch((error: any) => []);
        setPriorityoption(priorityapiresp);
    };

    const updateCalendarHeight = () => {
        const windowHeight = window.innerHeight;
        const headerHeight = 100; // Adjust based on your header height or layout
        console.log("Window height:", { windowHeight, headerHeight, diff: windowHeight - headerHeight - 150 });
        setCalendarHeight(windowHeight - headerHeight - 100);
    };

    const handleDatesSet = (info: any) => {
        const currentDayMonth = moment(info.view.currentStart, "YYYY-MM-DD").startOf("month");
        const cells = document.querySelectorAll(".fc-daygrid-day");
        cells.forEach((cell: any) => {
            const dataDate = moment(cell.getAttribute("data-date"), "YYYY-MM-DD").startOf("month");
            if (dataDate.isAfter(currentDayMonth) && cell.classList.contains("fc-day-future", "fc-day-other")) {
                // adding classList to hide future dates from the current month
                cell.classList.add("hidden");
            }
        });
    };

    useEffect(() => {
        init_master_data();
        init_page_date();
        console.log("Full Calendar Page Loaded");

    }, []);

    // Get users if not available
    useEffect(() => {
        if (users == null) {
            commonApi.GetUserList({
                pageNo: 1,
                pageSize: 1000
            }, (resp: any) => { }, (error: any) => { })
        }
    }, [users]);

    // Load filters from localStorage on component mount
    useEffect(() => {
        const savedFilters = localStorage.getItem('workOrderCalendarFilters');
        if (savedFilters) {
            try {
                const parsedFilters = JSON.parse(savedFilters);
                setFilters(parsedFilters);
            } catch (error) {
                console.error('Error parsing saved filters:', error);
                setFilters({});
            }
        } else {
            setFilters({});
        }
        setFiltersInitialized(true);
    }, []);

    // Save filters to localStorage when filters change
    useEffect(() => {
        if (Object.keys(filters).length > 0) {
            localStorage.setItem('workOrderCalendarFilters', JSON.stringify(filters));
        }
    }, [filters]);

    // Reload calendar events when filters change
    useEffect(() => {
        if (filtersInitialized && calendarRef.current) {
            getCalenderEvents();
        }
    }, [filters, filtersInitialized, selectedAssignType]);

    useEffect(() => {
        // Set the calendar height when the component mounts and whenever the window resizes
        updateCalendarHeight();
        window.addEventListener("resize", updateCalendarHeight);

        return () => {
            window.removeEventListener("resize", updateCalendarHeight);
        };
    }, []);

    // Set filters applied state
    useEffect(() => {
        const filterConfig: filterConfigType[] = [
            { name: 'WO Number', type: 'text', key: 'woCode' },
            { name: 'Facility', type: 'dropdown', key: 'facilityIDs', options: facilityoption || [] },
            { name: 'Priority', type: 'dropdown', key: 'woPriorityIDs', options: priorityoption || [] },
            { name: 'Assign Type', type: 'dropdown', key: 'woAssignmentTypeIDs', options: assignmentTypelist || [] },
            { name: 'Assigned to', type: 'dropdown', key: 'assignedToIDs', options: users || [] },
            { name: 'Work Request ID', type: 'text', key: 'workRequestID' },
            { name: 'Planned Start Date', type: 'date', key: 'startDate' },
            { name: 'Planned End Date', type: 'date', key: 'endDate' },
        ];

        const hasActiveFilters = filterConfig.some((filter) => filters[filter.key]);
        setFiltersApplied({
            generalFilter: hasActiveFilters,
        });
    }, [filters, facilityoption, priorityoption, assignmentTypelist, users]);

    return (
        <div className={`p-5`}>
            {/* Filter section */}
            <div className='bg-[#FAFAFA] flex justify-between px-5 py-2 items-center mb-4 rounded-md'>
                {/* Left side buttons */}
                <div className='flex gap-4 items-center'>
                    <Button
                        theme='light'
                        onClick={() => filtersRef.current.showModal()}
                    >
                        Filter{" "}
                        <Icon
                            name='filter'
                            size={1.40}
                            className={filtersApplied.generalFilter ? "text-blue-700" : ""}
                        />
                    </Button>
                    <p
                        className='text-primary font-semibold text-sm cursor-pointer'
                        onClick={() => {
                            setFilters({});
                            localStorage.removeItem('workOrderCalendarFilters');
                        }}
                    >
                        Clear Filters
                    </p>
                </div>
            </div>

            {/* Custom header toolbar */}
            <div className={`flex items-center justify-between gap-2 mb-4`}>
                <div className={`flex items-center border border-[#2D6A32] rounded-md`}>
                    <button className={`p-2 text-[13px] font-semibold border-r w-16 ${isToday ? `bg-[#2D6A32] text-white` : ``}`} onClick={() => navigateCalendar(`today`)}>Today</button>
                    <button className={`p-2 text-[13px] font-semibold border-r w-16 cursor-pointer`} onClick={() => navigateCalendar(`prev`)}>Prev</button>
                    <button className={`p-2 text-[13px] font-semibold w-16 cursor-pointer`} onClick={() => navigateCalendar(`next`)}>Next</button>
                </div>
                <div className={`text-md font-bold text-black grow text-center`}>{(() => {
                    return headerDatetext
                }
                )()}
                </div>
                <div className={`flex items-center gap-3`}>
                    <div className={`flex items-center gap-2 date-and-assign-type-list`}>
                        <form>
                            {/* <Controller
                                name="assignmentType"
                                control={control}
                                render={({ field: { value, onChange } }) => (
                                    <SelectBox
                                        label=""
                                        value={value}
                                        onChange={(type: any) => {
                                            onChange(type);
                                            getCalenderEvents();
                                        }}
                                        placeholder="Choose Assignment Type"
                                        className={`mt-0 !w-36`}
                                        options={assignmentTypelist ? assignmentTypelist : []}
                                        error={errors.workOrderStatusID?.message as any}
                                    />
                                )}
                            /> */}
                            <Controller
                                name="assignmentType"
                                control={control}
                                render={({ field: { value, onChange } }) => (
                                    <SelectBox
                                        label=""
                                        value={value}
                                        onChange={(type: any) => {
                                            onChange(type);
                                            getCalenderEvents();
                                        }}
                                        placeholder="Choose Assignment Type"
                                        className={`mt-0 !w-36`}
                                        options={[
                                            { label: "All", value: 0 },
                                            ...(assignmentTypelist || []),
                                        ]}
                                        error={errors.workOrderStatusID?.message as any}
                                    />
                                )}
                            />


                        </form>
                    </div>
                    {/*
                <div className={ `flex items-center border border-[#2D6A32] rounded-md` }>
                    <button className={ `p-2 text-[13px] font-semibold w-16 border-r cursor-pointer ${calendarView == `dayGridDay`? `bg-[#2D6A32] text-white`: ``}` } onClick={() => changeCalendarView(`dayGridDay`)}>Day</button>
                    <button className={ `p-2 text-[13px] font-semibold w-16 border-r cursor-pointer ${calendarView == `dayGridWeek`? `bg-[#2D6A32] text-white`: ``}` } onClick={() => changeCalendarView(`dayGridWeek`)}>Week</button>
                    <button className={ `p-2 text-[13px] font-semibold w-16 cursor-pointer ${calendarView == `dayGridMonth`? `bg-[#2D6A32] text-white`: ``}` } onClick={() => changeCalendarView(`dayGridMonth`)}>Month</button>
                </div>
                */}
                </div>
            </div>
            {/* Full Calendar Component */}
            <div className={`[&_.fc-col-header-cell]:bg-[#F0F0F0] [&_.fc-col-header-cell]:!py-1.5 [&_.fc-col-header-cell]:text-[13px] [&_.fc-col-header-cell]:font-semibold [&_.fc-col-header-cell]:text-[#262A2D]`}>
                <FullCalendar
                    ref={calendarRef}
                    plugins={[dayGridPlugin, interactionPlugin]}
                    weekends={true}
                    initialView={calendarView}
                    selectable={canEdit}
                    editable={canEdit}
                    droppable={canEdit}
                    datesSet={(dateInfo: any) => {
                        console.log("Date set", dateInfo);
                        moment().isBetween(moment.utc(dateInfo.startStr).local(), moment.utc(dateInfo.endStr).subtract(1, `seconds`).local()) ? setIsToday(true) : setIsToday(false);
                        console.log(dateInfo.view.getCurrentData())
                        let text: string = ``;
                        switch (dateInfo.view.type) {
                            case `dayGridDay`: {
                                text = moment.utc(dateInfo.startStr).local().format(`MMMM DD, YYYY`);
                                break;
                            }
                            case `dayGridWeek`: {
                                text = moment.utc(dateInfo.startStr).local().format(`MMMM DD, YYYY`) + ` - ` + moment.utc(dateInfo.endStr).subtract(1, `seconds`).local().format(`MMMM DD, YYYY`);
                                break;
                            }
                            case `dayGridMonth`: {
                                text = dateInfo.view.getCurrentData().viewTitle;
                                break;
                            }
                        }
                        setHeaderDateText(text);
                        handleDatesSet(dateInfo);
                    }}
                    select={(data: any) => {
                        if (!canEdit) {
                            toast.error("You don't have permission to create Tasks");
                            return;
                        }
                        console.log("Date clicked", data);
                        setSelectedDateEvent(data);
                        console.log("Selected date event", moment.utc(data.start).local().format(`YYYY-MM-DD`));
                        blankDateOption.current?.showModal();
                    }}
                    eventClick={(data: any) => {
                        console.log("Event clicked", data);
                        var WO = data.event._def.extendedProps.wo;
                        // Direct navigation to Task details page
                        window.open(URLS.WORK_ORDER_DETAILS(WO?.workOrderID), '_blank');
                        
                        // Old modal code - commented out
                        // setSelectedEvent(WO);
                        // eventOption.current?.showModal();
                    }}
                    //Internal calendar events drag start callback
                    eventDragStart={(data: any) => {
                        console.log("Event drag started", data);
                    }}
                    //Internal calendar events on drop callback
                    eventDrop={(data: any) => {
                        if (!canEdit) {
                            toast.error("You don't have permission to modify Tasks");
                            data.revert();
                            return;
                        }
                        console.log("Event dropped", data);
                        var WO = data.event._def.extendedProps.wo;

                        // Calculate the new dates based on the drop
                        const originalStartMoment = moment.utc(WO.startDate).local();
                        const originalEndMoment = moment.utc(WO.endDate).local();
                        const droppedDate = moment(data.event.start).local().format('YYYY-MM-DD'); // Get the exact dropped date

                        // Store the drop information and Task data with updated dates
                        setSchedulerDropInfo(data);
                        setSchedulerEditData({
                            ...WO,
                            // Set both start and end dates to the dropped date with preserved times
                            newDropStartDate: droppedDate,
                            newDropStartTime: originalStartMoment.format('HH:mm:ss'),
                            newDropEndDate: droppedDate, // Same date as start date
                            newDropEndTime: originalEndMoment.format('HH:mm:ss'),
                            startDate: droppedDate + ' ' + originalStartMoment.format('HH:mm:ss'),
                            endDate: droppedDate + ' ' + originalEndMoment.format('HH:mm:ss')
                        });

                        // Open the scheduler popup
                        schedulerDrawerRef.current?.open();

                        // Revert the calendar change temporarily until user confirms
                        data.revert();
                    }}
                    //External calendar events on drop callback
                    drop={(data: any) => {
                        console.log("External Event dropped on calendar", data);

                    }}
                    //Internal calendar events drag and drop
                    eventAllow={(dropInfo, draggedEvent) => {
                        return true; // ✅ allow all internal events to be dropped
                        const blockedDates = [`2025-07-02`, `2025-07-01`]; // example blocked dates
                        const dropDate = dropInfo.startStr.split('T')[0];
                        return !blockedDates.includes(dropDate); // ❌ deny if in blocked list
                    }}
                    //External events to drag and drop
                    eventReceive={(info) => {
                        const blockedDates = [`2025-07-05`];
                        const dropDate = info.event.startStr.split('T')[0];
                        if (blockedDates.includes(dropDate)) {
                            info.event.remove();
                            alert("You cannot drop events on this date.");
                        }
                        console.log(calendarRef.current.getApi().getCurrentData());
                        console.log("External event received", info);
                    }}
                    events={eventsData}
                    eventContent={(arg) => (
                        <Tippy className={`!bg-grey-300`} animation={`scale`} allowHTML={true} theme={`material`} content={
                            <div className={`p-2 rounded-md shadow text-[13px]`}>
                                <div className={`mb-1`}>WO Number: {arg.event.extendedProps.wo.workOrderCode}</div>
                                <div className={`mb-1`}>Title: {arg.event.extendedProps.description || arg.event.title}</div>
                                <div>Date: {moment.utc(arg.event.start).local().format(`MMMM DD, YYYY`)}</div>
                                <div className={`mb-1`}>Assigned to: {arg.event.extendedProps.wo.woUserMappings}</div>
                            </div>
                        }>
                            <div className={`overflow-hidden truncate`}>{arg.event.title}</div>
                        </Tippy>
                    )}
                    headerToolbar={false}
                    contentHeight={calendarHeight}
                    dayMaxEventRows={5}
                    dayCellClassNames={"equal-height"}
                    stickyHeaderDates={true}
                // dayMaxEvents={true}
                // handleWindowResize={true}
                // showNonCurrentDates={false}
                />
            </div>




            <dialog
                ref={blankDateOption}
                className="modal"
                onClose={() => {
                    console.log("Dialog closed");
                    blankDateOption.current?.close();
                }}
            >
                <div className="modal-box">
                    <p className="text-center">{selectedDateEvent ? moment.utc(selectedDateEvent.start).local().format(`YYYY-MM-DD`) : ''}</p>
                    <div className="flex justify-center mt-8">

                        <Button
                            theme="dark"
                            disabled={!canEdit}
                            onClick={() => {
                                if (!canEdit) {
                                    toast.error("You don't have permission to create schedules");
                                    return;
                                }
                                createScheduleOn(moment.utc(selectedDateEvent.start).local());
                                blankDateOption.current?.close();
                            }}
                        >
                            Create Schedule
                        </Button>
                        &nbsp;
                        <Button
                            disabled={!canEdit}
                            onClick={() => {
                                if (!canEdit) {
                                    toast.error("You don't have permission to create Tasks");
                                    return;
                                }
                                createWorkOrderOn(moment.utc(selectedDateEvent.start).local());
                                blankDateOption.current?.close();
                            }}
                        >
                            Create Task
                        </Button>
                    </div>
                </div>
                <form method="dialog" className="modal-backdrop">
                    <button>close</button>
                </form>
            </dialog>

            {/* Old modal code for event click - commented out as we now navigate directly */}
            {/* <dialog
                ref={eventOption}
                className="modal"
                onClose={() => {
                    console.log("Dialog closed");
                    eventOption.current?.close();
                }}
            >
                <div className="modal-box">
                    <div className="flex justify-center mt-8">
                        <Link to={URLS.WORK_ORDER_DETAILS(selectedEvent?.workOrderID)} target="_blank" >
                            <Button
                                theme="dark"
                                onClick={() => {
                                    console.log("Dialog cancelled");
                                    eventOption.current?.close();
                                }}
                            >
                                View Task
                            </Button>
                        </Link>

                        &nbsp;
                        <Button
                            disabled={!canEdit}
                            onClick={() => {
                                if (!canEdit) {
                                    toast.error("You don't have permission to assign Tasks");
                                    return;
                                }
                                assignToModal.current?.showModal();
                                eventOption.current?.close();
                            }}
                        >
                            Asign To
                        </Button>
                    </div>
                </div>
                <form method="dialog" className="modal-backdrop">
                    <button>close</button>
                </form>
            </dialog> */}


            {/* AssignToModal - commented out as it was part of the old modal flow */}
            {/* <AssignToModal _ref={assignToModal} assignmentTypes={assignmentTypelist} assignmentType={selectedAssignType} workOrder={selectedEvent} onCreate={getCalenderEvents} /> */}

            {/* Scheduler Popup Drawer for Drag & Drop */}
            <Drawer
                _ref={schedulerDrawerRef}
                onClose={() => {
                    schedulerModalRef?.current?.reset();
                    setSchedulerEditData(null);
                    setSchedulerDropInfo(null);
                }}
                outsideClose={false}
            >
                <Drawer.Button></Drawer.Button>
                <Drawer.Content
                    title="Reschedule Task"
                    className="!w-[45rem]"
                >
                    <ScheduleModalWorkOrder
                        _ref={schedulerModalRef}
                        editData={schedulerEditData}
                        currentStatus={2} // Status for scheduled
                        isAssignonly={false}
                        onCreate={() => {
                            schedulerDrawerRef?.current?.close();
                            setSchedulerEditData(null);
                            setSchedulerDropInfo(null);
                            getCalenderEvents(); // Refresh calendar events
                        }}
                        onCancel={() => {
                            schedulerDrawerRef?.current?.close();
                            setSchedulerEditData(null);
                            setSchedulerDropInfo(null);
                        }}
                    />
                </Drawer.Content>
            </Drawer>

            {/* Filters Modal */}
            <Filters
                _ref={filtersRef}
                config={[
                    { name: 'WO Number', type: 'text', key: 'woCode' },
                    { name: 'Facility', type: 'dropdown', key: 'facilityIDs', options: facilityoption || [] },
                    { name: 'Priority', type: 'dropdown', key: 'woPriorityIDs', options: priorityoption || [] },
                    { name: 'Assign Type', type: 'dropdown', key: 'woAssignmentTypeIDs', options: assignmentTypelist || [] },
                    { name: 'Assigned to', type: 'dropdown', key: 'assignedToIDs', options: users || [] },
                    { name: 'Work Request ID', type: 'text', key: 'workRequestID' },
                    { name: 'Planned Start Date', type: 'date', key: 'startDate' },
                    { name: 'Planned End Date', type: 'date', key: 'endDate' },
                ]}
                filters={filters}
                onUpdate={(data: any) => {
                    setFilters(data);
                }}
            />


        </div>
    );
};

export default CalendarWO;
